import React from "react";
import { keyframes } from "@emotion/react";
import { useTheme } from "@mui/material";
import CustomContainer from "../components/CustomContainer";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { SkillsProps } from "../@types/types";

const moveAnimation = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const AnimatedContainer = styled(Box)`
  display: flex;
  flex-wrap: nowrap;
  width: calc(260%);
  animation: ${moveAnimation} 40s linear infinite;
`;

const Skills = ({ skills }: SkillsProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const AnimatedImage = styled("img")(() => ({
    height: "70px",
    width: "70px",
    margin: "0 10px",
    [theme.breakpoints.up("sm")]: {
      width: "100px",
    },
    [theme.breakpoints.up("md")]: {
      width: "120px",
    },
  }));

  return (
    <CustomContainer id="#skills">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h3" component="h2" gutterBottom>
          {t("Skills")}
        </Typography>
      </Box>

      <Box sx={{ overflow: "hidden", width: "100%" }}>
        <AnimatedContainer>
          <Box sx={{ display: "flex" }}>
            {skills.map((skill, index) => (
              <AnimatedImage key={index} src={skill.src} alt={skill.alt} />
            ))}
            {skills.map((skill) => (
              <AnimatedImage
                key={`${skill.alt}-repeat`}
                src={skill.src}
                alt={skill.alt}
              />
            ))}
          </Box>
        </AnimatedContainer>
      </Box>
    </CustomContainer>
  );
};

export default Skills;
